import { Card } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';
import { Badge } from '@/components/ui/badge';
import { Container } from 'lucide-react';
import { silos, getFraction } from '@/data/mockData';
import { t } from '@/i18n';
import { cn } from '@/lib/utils';

// Capacity → color: green (<70%), amber (70-90%), red (>90%)
function fillColor(pct) {
  if (pct >= 90) return 'bg-rose-500';
  if (pct >= 70) return 'bg-amber-500';
  return 'bg-emerald-500';
}

export const SilosPanel = ({ compact = false }) => {
  return (
    <Card className={cn('p-4 bg-white/80 backdrop-blur-md', compact && 'p-3')}>
      <div className="flex items-center gap-2 mb-3">
        <Container className="h-4 w-4 text-primary" />
        <h3 className="font-semibold text-sm">{t('supplyChain.node.silo')} — {silos.length}</h3>
      </div>
      <div className="space-y-2.5">
        {silos.map(silo => {
          const fillPct = Math.round((silo.contentT / silo.capacityT) * 100);
          const fraction = getFraction(silo.fractionId);
          return (
            <div key={silo.id} className="space-y-1">
              <div className="flex items-center justify-between gap-2">
                <span className="text-xs font-medium truncate">{silo.name}</span>
                {fraction && (
                  <Badge
                    variant="outline"
                    className="text-[9px] px-1 py-0 border font-medium uppercase"
                    style={{ borderColor: fraction.color }}
                  >
                    {t(fraction.labelKey)}
                  </Badge>
                )}
              </div>
              <div className="relative">
                <Progress value={fillPct} className="h-2" indicatorClassName={fillColor(fillPct)} />
              </div>
              <div className="flex items-center justify-between text-[10px] text-muted-foreground tabular-nums">
                <span>{silo.contentT} / {silo.capacityT} t</span>
                <span>{silo.fillTimeMinPerT.toFixed(1)} min/t · {t('supplyChain.siloFillTime')}</span>
              </div>
            </div>
          );
        })}
      </div>
    </Card>
  );
};
